export const PRESET_CATALOG = {
    realistic: {
        id: 'realistic',
        name: 'Realistic',
        pipeline: 'single',
        word_budget: 100,
        conditional_segments: {
            supports_style_authority: true,
            supports_style_enhancement: false,
            supports_photo_language: true,
            supports_brand_context: true,
            supports_text_rendering_boost: true,
            anti_ai_without_references: false,
        },
    },
    flat_illustration: {
        id: 'flat_illustration',
        name: 'Flat Illustration',
        pipeline: 'single',
        word_budget: 120,
        conditional_segments: {
            supports_style_authority: true,
            supports_style_enhancement: true,
            supports_photo_language: false,
            supports_brand_context: true,
            supports_text_rendering_boost: true,
            anti_ai_without_references: true,
        },
    },
    pixel_art: {
        id: 'pixel_art',
        name: 'Pixel Art',
        pipeline: 'single',
        word_budget: 100,
        conditional_segments: {
            supports_style_authority: true,
            supports_style_enhancement: true,
            supports_photo_language: false,
            supports_brand_context: true,
            supports_text_rendering_boost: true,
            anti_ai_without_references: true,
        },
    },
    isometric: {
        id: 'isometric',
        name: 'Isometric',
        pipeline: 'single',
        word_budget: 100,
        conditional_segments: {
            supports_style_authority: true,
            supports_style_enhancement: true,
            supports_photo_language: false,
            supports_brand_context: true,
            supports_text_rendering_boost: true,
            anti_ai_without_references: true,
        },
    },
    logo: {
        id: 'logo',
        name: 'Logo',
        pipeline: 'single',
        word_budget: 80,
        conditional_segments: {
            supports_style_authority: true,
            supports_style_enhancement: true,
            supports_photo_language: false,
            supports_brand_context: true,
            supports_text_rendering_boost: true,
            anti_ai_without_references: false,
        },
    },
    custom: {
        id: 'custom',
        name: 'Custom',
        pipeline: 'single',
        word_budget: 200,
        conditional_segments: {
            supports_style_authority: true,
            supports_style_enhancement: false,
            supports_photo_language: false,
            supports_brand_context: true,
            supports_text_rendering_boost: true,
            anti_ai_without_references: false,
        },
    },
};
export const PRESET_NAMES = Object.fromEntries(Object.entries(PRESET_CATALOG).map(([key, preset]) => [key, preset.name]));
//# sourceMappingURL=presets.js.map